import { createElementBlock as r, openBlock as t, normalizeClass as a, renderSlot as l } from "vue";
/* empty css                     */
const p = /* @__PURE__ */ Object.assign({
  name: "DsTableRowGroup"
}, {
  __name: "table-row-group",
  props: {
    noDivider: { type: Boolean, default: !1 },
    stretch: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (o, s) => (t(), r("div", {
      class: a(["ds-table__row-group", { "ds-table__row-group-no-divider": e.noDivider, "ds-table__row-group--stretched": e.stretch }]),
      role: "rowgroup"
    }, [
      l(o.$slots, "default")
    ], 2));
  }
});
export {
  p as default
};
